// Beta-Onboarding (STILL) — TEMPORÄR während der Beta. NACH der Beta entfernen:
// diese Datei + den isBeta-Zweig in UserPlanContext + den ?beta=1-Button auf der Homepage.
// Flow: "Beta-Tester werden" (redcrypto.de) → app.redcrypto.de/?beta=1 → normaler
// Login → UserPlanContext liest ?beta=1 beim Konto-Init → still VIP (1 Jahr) + Zähler.
// KEIN Eingriff ins Login-UI (das war der frühere Fehler mit „zwei Screens").
import { db } from '../firebase';
import { doc, writeBatch, increment, serverTimestamp } from '../lib/fsCompat';

export const BETA_VIP_DAYS = 365;

// Legt betaSignups/{uid} an (einmal pro Konto, Rule-geschützt) und erhöht den
// öffentlichen Zähler (+1). MUSS vor dem VIP-Write laufen, weil die Firestore-Rule
// den VIP-Tier nur erlaubt, wenn betaSignups/{uid} existiert. Fehler werden geschluckt.
export async function claimBetaCounter(uid) {
  try {
    const batch = writeBatch(db);
    batch.set(doc(db, 'betaSignups', uid), { at: serverTimestamp() });
    batch.update(doc(db, 'meta', 'betaCounter'), { count: increment(1), updatedAt: serverTimestamp() });
    await batch.commit();
  } catch (e) {
    console.warn('[beta] Zähler-Claim übersprungen:', e?.message);
  }
}
